// extracted by mini-css-extract-plugin
module.exports = {"DateTime":"DateTime_DateTime__GeHrc","Display":"DateTime_Display__3ve2j","Value":"DateTime_Value__dKY_2","Icon":"DateTime_Icon__ahabb"};